
export const GET_RESET = "reset";
export const GET_WHY = "getWhy"
export const GET_SLIDER = "getSlider";
export const GET_GRID = "getGrid";
export const GET_HINT = "getHint";
export const GET_TOPIC_NEWS = "getTopicNews";
export const GET_CONTACT_DETAILS = "getContactDetails";
export const GET_SOCIAL = "getSocial";

